/** ととのう固定費のプラン表記（アプリ内 `MoneyStrongPlanCopy` および App Store と揃える） */
export const MONEY_STRONG_PLAN_NAME = "お金に強くなるプラン";

/** 初回リリースで有料となる機能の説明 */
export const MONEY_PAID_FEATURE_DESCRIPTION =
  "編集画面の「ローン詳細情報」（繰上返済・金利変更・ボーナス返済・手数料設定等の高度な入力・シミュレーション）";

export const MONEY_PHASE1_SCOPE_NOTE =
  "初回リリース時点では、上記のローン詳細情報のみがお金に強くなるプランの対象です。固定費の一覧・閲覧詳細・ローンの基本入力・月次明細の表示は無料です。クラウド同期等は今後、お金に強くなるプランに追加される予定です。";

export const MONEY_FUTURE_PAID_FEATURES =
  "クラウド同期・複数端末でのデータ引き継ぎ、長期予測の拡張、予兆通知、固定費目標アシスト 等";
